import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const getVenues = async (): Promise<any> => {
  return fetch(`${API_URL}/venues`, {});
};
